export default __webpack_public_path__ + "static/media/auth-decor-lines.a3bffade.svg";